import React from 'react';
import { Link } from 'react-router-dom';
import { Music2, Instagram, Facebook, Youtube, Twitter } from 'lucide-react';
import { footerLinks } from '../mock';

const Footer = () => {
  const renderLink = (l) => {
    if (l.href.startsWith('http')) {
      return (
        <a
          href={l.href}
          target="_blank"
          rel="noreferrer"
          className="text-neutral-400 hover:text-[#E9C46A] text-sm link-transition"
        >
          {l.label}
        </a>
      );
    }
    if (l.href.startsWith('/#') || l.href === '#') {
      return (
        <a
          href={l.href.startsWith('/#') ? l.href.substring(1) : l.href}
          className="text-neutral-400 hover:text-[#E9C46A] text-sm link-transition"
        >
          {l.label}
        </a>
      );
    }
    return (
      <Link
        to={l.href}
        className="text-neutral-400 hover:text-[#E9C46A] text-sm link-transition"
      >
        {l.label}
      </Link>
    );
  };

  return (
    <footer className="relative bg-black border-t border-white/[0.06] pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <img
                src="/logo-werdi-media.png"
                alt="Werdi Media"
                className="w-11 h-11 object-contain"
              />
              <div>
                <p className="text-white font-bold text-lg">Werdi Media</p>
                <p className="text-[10px] tracking-[0.25em] uppercase text-[#D4A94F] font-medium">
                  Music Distribution
                </p>
              </div>
            </Link>
            <p className="text-neutral-400 leading-relaxed mb-6 max-w-sm">
              Distribusi musik Indonesia ke platform digital worldwide.
              Rilis, lindungi, dan monetisasi karya musik Anda dengan mudah.
            </p>

            <div className="flex gap-3">
              {[
                { icon: Instagram, target: '_blank', href: 'https://instagram.com/werdimedia' },
                { icon: Facebook, target: '_blank', href: 'https://facebook.com/werdimedia' },
                { icon: Youtube, target: '_blank', href: 'https://youtube.com/werdimedia' },
                { icon: Twitter, target: '_blank', href: 'https://twitter.com/werdimedia' },
              ].map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  className="w-10 h-10 rounded-full border border-white/10 hover:border-[#D4A94F] hover:bg-[#D4A94F]/10 flex items-center justify-center btn-transition group"
                >
                  <s.icon className="w-4 h-4 text-neutral-400 group-hover:text-[#E9C46A] btn-transition" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-8">
            {Object.entries(footerLinks).map(([category, links]) => (
              <div key={category}>
                <h4 className="text-white font-semibold text-sm uppercase tracking-widest mb-5">
                  {category}
                </h4>
                <ul className="space-y-3">
                  {links.map((l) => (
                    <li key={l.label}>{renderLink(l)}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-8 border-t border-white/[0.06] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-neutral-500 text-sm">
            © {new Date().getFullYear()} Werdi Media. All rights reserved.
          </p>
          <p className="text-neutral-500 text-sm">
            Made with <span className="text-[#E9C46A]">♥</span> in Indonesia
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
